var util = require('widgets-util');

function asyncEach(arr, func, callback) {
  var loaded = arr.length;
  util.forEach(arr, function(el) {
    func(el, function() {
      loaded--;

      if(loaded == 0 && callback) callback();
    });
  })
}

function asyncEachOrdered(arr, func, callback) {
  if(arr.length > 0) {
    var first = arr.shift();
    func(first, function() {
      asyncEachOrdered(arr, func, callback);
    })
  } else {
    callback();
  }
}

module.exports.each = asyncEach;

module.exports.eachOrdered = asyncEachOrdered;